import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 103vh;
`

export const GridVideos = styled.div`
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-columns: repeat(auto-fit, minmax(360px, 400px));
  gap: 60px;
  width: 100%;

  @media (max-width: 524px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`

export const VideoWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  min-width: 300px;
  border-radius: 0.625em;
  overflow: hidden;
  padding: 12px;
  background-color: ${({ theme }) => theme.cor5};
  box-sizing: border-box;

  @media (max-width: 524px) {
    min-width: 250px;
    max-width: 100%;
  }
`

export const ContainerVideo = styled.div`
  height: 17.1875em;
  width: 100%;
  background-color: black;
  border-radius: 0.625em;
  overflow: hidden;

  @media (max-width: 524px) {
    height: max-content;
  }
`

export const VideoIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0.625em;
`

export const ContainerDetalhesVideo = styled.div`
  padding: 24px 0.9375em 12px 0.9375em;
  width: 100%;
`

export const ContainerDescricaoVideo = styled.div`
  overflow: hidden;
  height: 4em;
`

export const TituloVideo = styled.h1`
  margin-bottom: 5px;
  height: 1.1875em;
  width: 12.25em;
  font-family: Roboto;
  font-size: 1em;
  font-weight: 700;
  line-height: 1.1875em;
  color: ${({ theme }) => theme.cor9};
`

export const DescricaoVideo = styled.span`
  font-family: Roboto;
  font-size: 0.875em;
  line-height: 1.3125em;
  color: ${({ theme }) => theme.cor9};
`

export const Divisoria = styled.div`
  height: 0.0625em;
  width: 100%;
  margin-top: 0.625em;
  margin-bottom: 0.625em;
  background-color: ${({ theme }) => theme.cor13};
`

export const ContainerDetalhes = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
`

export const ContainerUploaderVideo = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 6.25em);
`

export const ContainerFoto = styled.div`
  margin-right: 0.625em;
  margin-top: 0.255em;
`

export const FotoVideo = styled.img`
  height: 2.5em;
  width: 2.5em;
  border-radius: 50%;
`

export const ContainerApresentador = styled.div``

export const NomeApresentador = styled.span`
  font-family: Roboto;
  font-size: 0.875em;
  font-weight: 700;
  line-height: 1em;
  display: flex;
  color: ${({ theme }) => theme.cor9};
`

export const ContainerCargoApresentador = styled.div``

export const CargoApresentador = styled.span`
  font-family: Roboto;
  font-size: 0.875em;
  line-height: 1em;
  color: ${({ theme }) => theme.cor9};
`

export const ContainerTempo = styled.div`
  width: 6.25em;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const IconeRelogioVideo = styled.img`
  width: 1.25em;
  height: 1.25em;
`

export const TempoVideo = styled.span`
  font-family: Roboto;
  font-size: 1em;
  line-height: 2em;
  color: ${({ theme }) => theme.cor9};
`

// Componentes para skeleton
export const SkeletonTitulo = styled.div`
  margin-bottom: 5px;
`

export const SkeletonDescricao = styled.div`
  margin-top: 4px;
`

export const SkeletonFoto = styled.div`
  border-radius: 50%;
  overflow: hidden;
`

export const VideosHidden = styled.div`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
`

export const GridVideosHidden = styled.div`
  display: ${({ $show }) => ($show ? 'grid' : 'none')};
  justify-content: center;
  justify-items: center;
  grid-template-columns: repeat(auto-fit, minmax(360px, 400px));
  gap: 60px;
  width: 100%;

  @media (max-width: 524px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`

export const BlankSlateContainer = styled.div`
  height: 90vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
